import StocksGestionRapportActiviteSaveController from './stocks.gestion.rapport.activite.save.controller';
import Template from './stocks.gestion.rapport.activite.save.html';

export default {
	bindings: {
		data: '=',
		modalInstance: '='
	},
	controller: StocksGestionRapportActiviteSaveController,
	template: Template
};
